export default function MaterialIcon({
  icon,
  fontSize,
  className,
  title = '',
}: {
  icon: string
  fontSize?: number
  className?: string
  title?: string
}) {
  return (
    <span
      title={title}
      className={`material-icons ${className}`}
      style={{
        fontSize: fontSize ?? 'inherit',
      }}
    >
      {icon}
    </span>
  )
}
